import { IMAGE_TYPE } from 'ricos-content';
import type { Node } from 'ricos-schema';
import type { Helpers } from 'ricos-types';

import type { ImagePluginViewerConfig } from '../types';
import type { ImageClickActionHandle } from './get-image-click-action-config';

type UseExpandParams = {
  imageData: Node['imageData'];
  helpers: Helpers;
  config: ImagePluginViewerConfig;
  nodeId: string;
};

export const getExpandFunction = ({
  helpers,
  config,
  nodeId,
  imageData,
}: UseExpandParams): ImageClickActionHandle | undefined => {
  const { onExpand, disableExpand } = config;
  if (imageData?.disableExpand === true || disableExpand === true || !onExpand) {
    return;
  }

  return e => {
    e.preventDefault();
    helpers.onViewerAction?.(IMAGE_TYPE, 'Click', 'expand_image');
    onExpand(nodeId);
  };
};
